const CANVAS_BORDER_WIDTH = 1;

async function ensurePdfJsCSS() {
  const existingStylesheet = document.getElementById('pdfjs-stylesheet');

  if (existingStylesheet) return;

  const url = new URL('pdfjs-dist/web/pdf_viewer.css', import.meta.url).toString();

  const stylesheet = document.createElement('link');
  stylesheet.type = 'text/css';
  stylesheet.rel = 'stylesheet';
  stylesheet.href = url;
  stylesheet.id = 'pdfjs-stylesheet'

  document.getElementsByTagName('head')[0].appendChild(stylesheet);
}

function setupMutationObserver() {
  const DEL_SELECTOR = '.annotationLayer section:not(.linkAnnotation)';

  const mutationObserver = new MutationObserver(onMutation);

  observe();

  function onMutation(mutations) {
    let stopped;
    for (const {addedNodes} of mutations) {
      for (const node of addedNodes) {
        if (node.tagName) {
          if (node.matches(DEL_SELECTOR)) {
            stopped = true;
            mutationObserver.disconnect();
            node.remove();
          } else if (node.firstElementChild && node.querySelector(DEL_SELECTOR)) {
            stopped = true;
            mutationObserver.disconnect();
            for (const el of node.querySelectorAll(DEL_SELECTOR)) el.remove();
          }
        }
      }
    }
    if (stopped) observe();
  }

  function observe() {
    mutationObserver.observe(document, {
      subtree: true,
      childList: true,
    });
  }
}

function setupEvents(pdfSinglePageViewer, eventBus, onPDFLoad, onPageChange) {
  eventBus.on('pagesloaded', function () {
    pdfSinglePageViewer.currentScaleValue = (pdfSinglePageViewer.container.parentElement.parentElement.clientWidth /
      (pdfSinglePageViewer._pages[0].width + 2 * CANVAS_BORDER_WIDTH));

    onPDFLoad(pdfSinglePageViewer.viewer, pdfSinglePageViewer.container.parentElement);
  });

  eventBus.on('pagechanging', function (e) {
    onPageChange(e.pageNumber);
  });
}

function setupLinkService(eventBus, pdf, pdfjsViewer) {
  const pdfLinkService = new pdfjsViewer.PDFLinkService({
    eventBus,
  });

  pdfLinkService.externalLinkTarget = pdfjsViewer.LinkTarget.BLANK;
  pdfLinkService.setDocument(pdf, null);

  return pdfLinkService;
}

function setupViewer(eventBus, pdf, pdfLinkService, container, pdfjsViewer) {
  const pdfSinglePageViewer = new pdfjsViewer.PDFSinglePageViewer({
    container,
    eventBus,
    linkService: pdfLinkService,
  });

  pdfSinglePageViewer.renderInteractiveForms = false;
  pdfLinkService.setViewer(pdfSinglePageViewer);
  pdfSinglePageViewer.setDocument(pdf);

  return pdfSinglePageViewer;
}

async function renderPdf({url, containerId, onPDFLoad = {}, onPageChange = {}}) {
  const pdfjsLib = await import('pdfjs-dist/build/pdf.mjs');
  const pdfjsViewer = await import('pdfjs-dist/web/pdf_viewer.mjs');

  setupMutationObserver();

  pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.mjs', import.meta.url).toString();

  let pdf;
  try {
    pdf = await pdfjsLib.getDocument({url}).promise;
  } catch (error) {
    if (error.name === 'PasswordException') {
      return {
        errors: {
          passwordProtected: error.message
        }
      };
    } else {
      throw error;
    }
  }

  ensurePdfJsCSS();

  const container = document.getElementById(containerId);
  if (!container) return;

  const eventBus = new pdfjsViewer.EventBus();

  const pdfLinkService = setupLinkService(eventBus, pdf, pdfjsViewer);

  const pdfSinglePageViewer = setupViewer(eventBus, pdf, pdfLinkService, container, pdfjsViewer);

  setupEvents(pdfSinglePageViewer, eventBus, onPDFLoad, onPageChange);

  return {pdf, viewer: pdfSinglePageViewer};
}

export default renderPdf;
